import { Module } from "vuex";
import { State } from "../store";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/plugins/firebase";
import { OtherUserData } from "@/common/types/OtherUserData";

export type UserState = {
  users: Map<string, OtherUserData>;
};

const userModule: Module<UserState, State> = {
  namespaced: true,
  state: {
    users: new Map<string, OtherUserData>(),
  },
  mutations: {
    setUser(state, user: OtherUserData) {
      state.users.set(user.uid, user);
    },
  },
  actions: {
    async getUser({ state, commit }, uid: string) {
      const user = state.users.get(uid);
      if (user !== undefined) {
        return user;
      }

      const fn = httpsCallable(functions, "user-get");
      const result = ((await fn({ uid: uid })) as { data: OtherUserData }).data;

      commit("setUser", result);
      return result;
    },
  },
};

export default userModule;
